export const EXCEPTION_MAP = {
    A0001: 'Can not calc interval'
};